import { Autocomplete } from 'src/components/Autocomplete';
import { Chip } from 'src/components/Chip';
import { TextField } from 'src/components/TextField';

interface ItemTypeFilterProps {
  field: string;
  label: string;
  value: string[] | undefined;
  setValue: (newVal: string[]) => void;
  valueOnly?: boolean;
}

const itemTypeOptions = [
  { label: 'Package', value: 'Fbm::Package' },
  { label: 'Service Fee', value: 'Fbm::Fee' },
  { label: 'Group', value: 'Group' },
  { label: 'Plan', value: 'WorkoutPlan' },
  { label: 'Product', value: 'Exercisecom::Product' },
  { label: 'Online Training', value: 'ClientAssociation' },
  { label: 'Staff Subscription', value: 'TrainerAssociation' },
];

export const ItemTypeFilter: React.FC<ItemTypeFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedValues = value ? String(value).split(',') : [];

  if (valueOnly) {
    return selectedValues.length > 0 ? (
      <>
        {selectedValues
          .map(
            (v) =>
              itemTypeOptions.find((option) => option.value === v)?.label || ''
          )
          .join(', ')}
      </>
    ) : null;
  }

  return (
    <Autocomplete
      multiple
      options={itemTypeOptions.map((e) => e.value)}
      getOptionLabel={(option) =>
        itemTypeOptions.find((e) => e.value === option)?.label || ''
      }
      value={selectedValues}
      onChange={(_, newValue) => setValue(newValue.join(','))}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={!selectedValues.length ? 'Any' : ''}
        />
      )}
      renderTags={(value: readonly string[], getTagProps) =>
        value.map((option: string, index: number) => {
          const name =
            itemTypeOptions.find((e) => e.value === option)?.label || 'Unknown';
          const { key, ...tagProps } = getTagProps({ index });
          return <Chip label={name} key={key} {...tagProps} />;
        })
      }
    />
  );
};
